<template>
  <div class="_content md-elevation-1">

    <div class="md-autocomplete-loading" v-if="isBusy">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>

    <collapse :collapse="['FILTERS']" icon="keyboard_arrow_down" :defaultActive="1">
      <template slot="md-collapse-pane-1">
        <div class="md-layout">

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field class="_uiKitInput">
              <label>Search</label>
              <md-input v-model="form.query" md-autogrow></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field class="_uiKitInput">
              <label>Document Type</label>
              <md-select v-model="form.type">
                <md-option
                  v-for="(_option, _index) in docTypes"
                  :key="_index"
                  :value="_option.id"
                  >{{ _option.label }}</md-option
                >
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-button 
              class="md-primary space" 
              @click="atSearch"
            ><md-icon>search</md-icon>Search </md-button>
            <md-button 
              class="space" 
              @click="onFormReset"
            ><md-icon>search</md-icon>Clear Filters </md-button>
          </div>

        </div>
      </template>
    </collapse>
  </div>
</template>

<script>
import { Collapse } from "@/components";

export default {
  name: 'AttachmentsFilter',
  components: {
    Collapse,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    atSearch: {
      type: Function,
      required: true,
    },
    atFormReset: {
      type: Function,
      required: true,
    },
    docTypes: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    form: {
      query: null,
      type: null,
    },
    isBusy: false,
  }),
  methods: {
    /**
     * Reset filter form model
     * @return {void}
     */
    onFormReset() {
      this.$set(this, 'form', {
        query: null,
        type: null,
      });
      this.atFormReset();
    },
  },
  watch: {
    /**
     * Whenever any value changes in form model - emit the new model value
     */
    'form': {
      deep: true,
      immediate: true,
      handler: function() {
        this.$emit('input', this.form);
      }
    }
  },
};
</script>

<style lang="scss">
</style>
